import { css } from '@emotion/react';
import getConfirmationModalStyles from './_confirmation-modal.css';
import getFileFieldStyles from './_file-field.css';
import getFileInputStyles from './_file-input.css';
import getItemDetailsStyles from './_item-details.css';
import getLoaderStyles from './_loader.css';
import getNavMenuStyles from './_nav-menu.css';
import getUweentityAssignmentsStyles from './_uweentity-assignments.css';
import getUweentityHistoryStyles from './_uweentity-history.css';
import getUweentityNotesStyles from './_uweentity-notes.css';
import getUweentityProgressStyles from './_uweentity-progress.css';
import getWaitForUweentityFilesStyles from './_wait-for-uweentity-files.css';
import getIntegrationUserStyles from './_integration-user.css';
import getSignatureFieldStyles from './_signature-field.css';
import getEditorContainerStyles from './_editor-container.css';
import getEntityEditorStyles from './_entity-editor.css';
import getUweSidebarpanelFormStyles from './_uwe-sidebarpanel-form.css';
import getInteractiveDrawingStyles from './_interactive-drawing.css';
import getSwitchStyles from './_switch.css';
import getJsonTreeEditorStyles from './_json-tree-editor.css';
import getFormComparisonStyles from './_form-comparison.css';
import getJsonSchemaTreeEditorStyles from './_json-schema-tree-editor.css';
import getSelectImageFieldStyles from './_select-image-field.css';
import getOrganizationalUnitTreeNodeStyles from './_organizational-unit-tree-node.css';
import getCollapsableTreeSelectStyles from './_collapsable-tree-select.css';
import getButtonBarStyles from './_button-bar.css';
import getWorkflowBuilderStyles from './_workflow-builder';
import getEditableSchemaFieldTemplateStyles from './_editable-schema-field-template';

const styles = [
  getConfirmationModalStyles,
  getFileFieldStyles,
  getFileInputStyles,
  getItemDetailsStyles,
  getLoaderStyles,
  getNavMenuStyles,
  getUweentityAssignmentsStyles,
  getUweentityHistoryStyles,
  getUweentityNotesStyles,
  getUweentityProgressStyles,
  getWaitForUweentityFilesStyles,
  getIntegrationUserStyles,
  getSignatureFieldStyles,
  getEditorContainerStyles,
  getEntityEditorStyles,
  getUweSidebarpanelFormStyles,
  getInteractiveDrawingStyles,
  getSwitchStyles,
  getJsonTreeEditorStyles,
  getFormComparisonStyles,
  getJsonSchemaTreeEditorStyles,
  getSelectImageFieldStyles,
  getOrganizationalUnitTreeNodeStyles,
  getCollapsableTreeSelectStyles,
  getButtonBarStyles,
  getWorkflowBuilderStyles,
  getEditableSchemaFieldTemplateStyles,
];

export default $ => css(styles.map(style => style($)));
